import { cn } from '@/lib/utils'

interface SpinnerProps {
  /** 스피너 크기 */
  size?: 'sm' | 'md' | 'lg'
  /** 추가 CSS 클래스 */
  className?: string
}

const sizeStyles = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-3',
} as const

/**
 * 로딩 스피너 컴포넌트.
 * 데이터 로딩 중 사용자에게 진행 상태를 알립니다.
 */
export default function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="로딩 중"
      className={cn(
        'animate-spin rounded-full border-cb-gray-200 border-t-cb-primary',
        sizeStyles[size],
        className
      )}
    >
      <span className="sr-only">로딩 중...</span>
    </div>
  )
}
